import {
  initialState,
  Actions,
  State,
  DELETE_CATEGORY,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_ERROR,
  RESET_DELETE_CATEGORY,
} from "../../types/category/delete-category";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_CATEGORY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_CATEGORY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_CATEGORY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_CATEGORY:
      return initialState
    default:
      return state;
  }
};

export default reducers;
